import { usePage } from '@inertiajs/react'
import React from 'react'
import CookieConsentBanner from '~/components/CookieConsentBanner'
import { Footer } from '~/pages/website/components/Footer'
import { Navigation } from '~/pages/website/components/Navigation'

type PageLayoutProps = {
  children: React.ReactNode
}

export const PageLayout = ({ children }: PageLayoutProps) => {
  const { url } = usePage()

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navigation currentPath={url} />
      <div className="grow">{children}</div>
      <Footer />
      <CookieConsentBanner />
    </div>
  )
}
